// ═══════════════════════════════════════════════════════════
// top-jk-video.js — запуск видео ЖК в карточках «Популярные ЖК месяца»
// (jk-card-accuracy block E1.1, 2026-06-29).
//
// Проблема: <video class="city-jk-video"> рендерился с preload="none" без
// poster. На desktop hover делал его opacity:1, но видео было readyState 0 →
// чёрный кадр. На mobile (нет :hover) видео было скрыто (opacity:0) → юзер
// видел фото (ок), но видео ЖК не показывалось вовсе.
//
// Фикс (вместе с poster=фото ЖК + preload="metadata" в markup + CSS
// @media(hover:none){opacity:1}):
//   • Desktop (есть hover): pointerenter карточки → video.play();
//     pointerleave → pause() + reset (currentTime=0) → снова poster-кадр.
//   • Mobile / touch (hover:none): IntersectionObserver — видимая карточка
//     играет, ушедшая из viewport ставится на паузу (экономия трафика/батареи).
//   • poster гарантирует: до старта / при блоке autoplay виден кадр-фото ЖК,
//     НЕ чёрный экран.
//
// Идемпотентно: повторный scan() не дублирует обработчики (флаг dataset).
// Слушает 'bd:topjk-rendered' (index-city.js) — перепривязка после AJAX
// перерисовки карточек по гео.
//
// CSP-safe: нет inline-обработчиков; addEventListener + IntersectionObserver.
// IIFE + guard #topJkGrid (no-op вне главной). const/let + arrow внутри IIFE.
// ═══════════════════════════════════════════════════════════
(() => {
    'use strict';

    const grid = document.getElementById('topJkGrid');
    if (!grid) {
        return; // не главная — выходим
    }

    // touch-устройство: нет :hover → видео видно (CSS) и играет по видимости.
    const isTouch = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);

    /** Безопасный play() — autoplay policy может reject (на touch до жеста). */
    const safePlay = (video) => {
        if (!video || typeof video.play !== 'function') {
            return;
        }
        const p = video.play();
        if (p && typeof p.catch === 'function') {
            p.catch(() => { /* autoplay rejected — остаётся poster-кадр */ });
        }
    };

    /** Пауза + сброс к началу (снова показывается poster-кадр на desktop). */
    const resetVideo = (video) => {
        if (!video || typeof video.pause !== 'function') {
            return;
        }
        video.pause();
        try {
            video.currentTime = 0;
        } catch (_e) { /* до загрузки metadata currentTime может бросить — no-op */ }
    };

    // IntersectionObserver только для touch — играем видимую карточку.
    let io = null;
    if (isTouch && typeof IntersectionObserver === 'function') {
        io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting) {
                    safePlay(video);
                } else if (typeof video.pause === 'function') {
                    video.pause(); // off-screen → пауза (без reset, чтобы продолжить)
                }
            });
        }, { threshold: 0.5 });
    }

    /**
     * Привязать play-поведение ко всем .city-jk-video, ещё не обработанным.
     * Идемпотентно через data-tjv-bound.
     */
    const scan = () => {
        const videos = grid.querySelectorAll('.city-jk-video');
        videos.forEach((video) => {
            if (video.dataset.tjvBound === '1') {
                return;
            }
            video.dataset.tjvBound = '1';

            if (isTouch) {
                if (io) {
                    io.observe(video);
                } else {
                    safePlay(video); // нет IO — играем сразу (fallback)
                }
                return;
            }

            // Desktop: hover карточки → play / leave → reset.
            const card = video.closest('.top-jk-card');
            const target = card || video;
            target.addEventListener('pointerenter', () => safePlay(video));
            target.addEventListener('pointerleave', () => resetVideo(video));
        });
    };

    scan();

    // Перепривязка после AJAX-перерисовки (index-city.js по гео-детекту).
    document.addEventListener('bd:topjk-rendered', scan);

    // Экспорт для тестов / повторного скана.
    window.topJkVideo = { scan };
})();
